module.exports = __webpack_public_path__ + "static/media/4-thumb.965f5135.png";